import toggleVisibility from '../toggleVisibility';

const updateSelectedVariant = ({ variant, variantInventory = [], elements = {}, strings = {} }) => {
  const {
    productPreOrderMsg,
    productSoldInfo,
    productControls,
    klaviyoBIS,
    atcButtonMsg
  } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !variant.available && !isPreOrder;
  const isAvailable = variant.available;

  if (productPreOrderMsg) toggleVisibility(productPreOrderMsg, isPreOrder);
  if (productSoldInfo) toggleVisibility(productSoldInfo, !isPreOrder && isAvailable);
  if (klaviyoBIS) toggleVisibility(klaviyoBIS, isSoldOut);
  if (productControls) toggleVisibility(productControls, isAvailable);

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    atcButtonMsg.textContent = getAtcBtnText();
  }
};

export default updateSelectedVariant;
